import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type MemberRecurringOrders } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: MemberRecurringOrders.Api.InitRequest
  ): Promise<HttpApiResponse<MemberRecurringOrders.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/recurringOrders`, args),
  getDetail: (
    apiInfo: ModuleApiInfo,
    args: MemberRecurringOrders.Api.GetDetailRequest
  ): Promise<HttpApiResponse<MemberRecurringOrders.Api.GetDetailResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/recurringOrders/${args.id}`),
  updateDetail: (
    apiInfo: ModuleApiInfo,
    { id, ...data }: MemberRecurringOrders.Api.UpdateDetailRequest
  ): Promise<HttpApiResponse<MemberRecurringOrders.Api.UpdateDetailResponse>> =>
    api.put(apiInfo, `/api/site/v1/modules/member/recurringOrders`, data),

  downloadInvoice: (apiInfo: ModuleApiInfo, id: string): Promise<void> =>
    api.download(apiInfo, `/api/site/v1/modules/member/recurringOrders/${id}/invoice`)
};
